export const isDateNotInThePast = (date: Date, startDate?: string) => {
  const prevDay = startDate ? new Date(startDate) : new Date();
  prevDay.setDate(prevDay.getDate() - 1);
  return date.getTime() > prevDay.getTime();
};
